import TagsInput from './tags-input';

export { SuggestionsGroup } from './suggestions-group';
export { type TagsInputProps } from './tags-input';
export default TagsInput;
